<template>
  <div class="div-input">
    <div class="display-only" v-if="isDisplay"></div>
    <div :class="['input-custom', { error: isValidate }]">
      <label v-if="textFloat" :class="className">
        {{ textFloat }}
        <span v-if="isRequired" class="require-label">*</span>
      </label>
      <span v-if="textDescription" class="text-des">
        {{ textDescription }}
      </span>
      <select
        :class="['custom-select f-regular']"
        :name="name"
        :required="required"
        :value="value"
        @change="onSelectChange"
        ref="select"
        :disabled="isDisplay"
        :id="id"
      >
        <option :value="''" disabled v-if="placeholder">
          {{ placeholder }}
        </option>
        <option
          v-for="option in options"
          :key="getOptionValue(option)"
          :value="getOptionValue(option)"
        >
          {{ getOptionLabel(option) }}
        </option>
      </select>
      <div v-if="buttonAction" class="button-action" @click="buttonAction">
        <font-awesome-icon
          v-if="buttonActionIcon.length"
          :icon="buttonActionIcon"
          :class="[buttonActionClass]"
        />
      </div>
    </div>
    <span v-if="detail" class="text-desc">{{ detail }}</span>
    <div v-if="v && v.$error">
      <span class="text-error" v-if="v.required == false">
        {{
          cookieLang == "th"
            ? "กรุณาเลือกข้อมูลให้ครบถ้วน"
            : "This field can't be empty"
        }}
      </span>
      <span class="text-error" v-else-if="v.minLength == false">{{
        cookieLang == "th"
          ? "กรุณาเลือกอย่างน้อย " + v.$params.minLength.min + " รายการ"
          : "Please select at least " + v.$params.minLength.min + " items"
      }}</span>
      <span class="text-error" v-else-if="v.validateTotal == false">
        {{
          cookieLang == "th"
            ? "กรุณาเลือกข้อมูลให้ถูกต้อง"
            : "Please select data correctly"
        }}
      </span>
      <span class="text-error" v-else-if="v.maxLength == false">{{
        cookieLang == "th"
          ? "กรุณาเลือกไม่เกิน " + v.$params.maxLength.max + " รายการ"
          : "Please select no more than " + v.$params.maxLength.max + " items"
      }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      required: true,
      type: Object,
    },
    textFloat: {
      required: false,
      type: String,
    },
    textDescription: {
      required: false,
      type: String,
    },
    className: {
      required: false,
      type: String,
    },
    placeholder: {
      required: false,
      type: String,
    },
    required: {
      required: false,
      type: Boolean,
    },
    detail: {
      required: false,
      type: String,
    },
    name: {
      required: false,
      type: String,
    },
    value: {
      required: false,
      type: [String, Number],
    },
    options: {
      required: true,
      type: Array,
      default: () => [],
    },
    optionLabel: {
      required: false,
      type: String,
      default: "label",
    },
    optionValue: {
      required: false,
      type: String,
      default: "value",
    },
    isDisplay: {
      required: false,
      type: Boolean,
    },
    isRequired: {
      required: false,
      type: Boolean,
    },
    isValidate: {
      required: false,
      type: Boolean,
    },
    v: {
      required: false,
      type: Object,
    },
    buttonAction: {
      required: false,
      type: Function,
    },
    buttonActionClass: {
      required: false,
      type: String,
    },
    buttonActionIcon: {
      required: false,
      type: Array,
    },
    id: {
      required: false,
      type: String,
    },
  },
  mounted() {
    this.cookieLang = this.$cookies.isKey("d-lang")
      ? this.$cookies.get("d-lang")
      : "th";
  },
  methods: {
    onSelectChange(event) {
      const selectedValue = event.target.value;
      this.$emit("input", selectedValue);
      this.$emit("onDataChange", selectedValue);

      this.$cookies.set('d-lang', selectedValue);
    },
    getOptionLabel(option) {
      if (typeof option === "object" && option !== null) {
        return (
          option[this.optionLabel] ||
          option.label ||
          option.name ||
          option.text ||
          ""
        );
      }
      return option;
    },
    getOptionValue(option) {
      if (typeof option === "object" && option !== null) {
        return option[this.optionValue] || option.value || option.id || option;
      }
      return option;
    },
    focus() {
      this.$refs.select.focus();
    },
  },
  data() {
    return {
      primaryColor: this.config.color,
      cookieLang: "",
    };
  },
};
</script>

<style lang="scss" scoped>
* {
  font-family: inherit;
}
.div-input {
  margin-bottom: 10px;
  position: relative;
}
.input-custom {
  padding: 0px;
}
.input-custom > select:disabled {
  background-color: white;
}
.input-custom > label {
  color: #595a5c; // label form
  font-size: 16px;
  font-family: inherit;
}
.input-custom > select {
  border: 1px solid #99999959; // border select
  color: #000;
  background-color: white;
  border-radius: 6px;
  padding: 5px 10px;
  margin-top: 3px;
  font-size: 14px;
  min-height: 35px;
  appearance: none;
  background-image: url('data:image/svg+xml;charset=US-ASCII,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4 5"><path fill="%23666" d="M2 0L0 2h4zm0 5L0 3h4z"/></svg>');
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 12px;
  padding-right: 30px;
}
.input-custom > select:focus {
  outline: 0px;
  box-shadow: 1px 1px 3px #999999;
}
.input-custom.error > select {
  border-color: red !important;
}
.custom-select {
  display: block;
  border: none;
  width: -webkit-fill-available;
}
.text-desc {
  color: rgba(22, 39, 74, 0.4);
  font-size: 16px;
  font-family: inherit;
}
.display-only {
  position: absolute;
  z-index: 5;
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.text-error {
  color: #d3545d;
  font-size: 16px;
}

.button-action {
  position: absolute;
  right: 10px;
  top: 2.3rem;
  z-index: 6;
}
.text-des {
  color: #a0a0a0;
  font-size: 16px;
}
.button-action:hover {
  cursor: pointer !important;
}
.require-label {
  color: #ff0000;
}
label {
  margin-bottom: 0px;
}

// Customize select dropdown arrow for different browsers
select::-ms-expand {
  display: none;
}
</style>
